<template>
    <!-- Not Used -->
    <div class="page-layout blank">
        <div class="pb-10">
            <div class="row py-4">
                <div class="col-lg-3 col-md-6 col-sm-6 col-xs-6 col-xs-12 pl-0">
                    <div class="prodItem" style="margin-left:18px;">
                        <span class="prod-text">Connections (Contacts)</span>
                        <span class="prod-list-item">
                            <h4 id="prod-number">-</h4>
                            <div>
                                <img src="/static/images/ContactPeople.svg" id="GrpPeople" />
                                <img src="/static/images/ContactGroup.svg" id="grpconatct"
                                    style="width:58px;height:55px;" />
                            </div>
                        </span>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-6 col-xs-6 col-xs-12 pl-0">
                    <div class="prodItem">
                        <span class="prod-text">Call Reports</span>
                        <span class="prod-list-item">
                            <h4 id="prod-number">-</h4>
                            <span class>
                                <img src="/static/images/CallReport2.svg"
                                    style="position:relative;left:44px;height:25px;width:25px" alt />
                                <img src="/static/images/CallReport1.svg" style="width:58px;height:55px;" alt />
                            </span>
                        </span>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-6 col-xs-6 col-xs-12 pl-0">
                    <div class="prodItem">
                        <span class="prod-text">Contract</span>
                        <span class="prod-list-con">
                            <span class="text-center" style="margin-top:30px">
                                <p style="font-size:10px;margin-bottom:0px">Pending</p>
                                <h4 class style="font-weight:bold;font-size:15px">-</h4>
                            </span>
                            <img src="/static/images/Contract.svg" style="width:58px;height:55px;" alt />
                            <span class="text-center" style="margin-top:30px">
                                <p style="font-size:10px;margin-bottom:0px">Completed</p>
                                <h4 class style="font-weight:bold;font-size:15px">-</h4>
                            </span>
                        </span>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-6 col-xs-6 col-xs-12 pl-0">
                    <div class="prodItem">
                        <span class="prod-text">Preferences</span>
                        <div class="preference-item">
                            <span class="prefer-list">
                                <img src="/static/images/images-new-theme/icons/food.svg" style="width:22px;height:15px;margin:0px 12px" alt />
                                <p>Food</p>
                            </span>
                            <span class="prefer-list">
                                <img src="/static/images/images-new-theme/icons/HotelBed.svg" style="width:22px;height:15px;margin:0px 12px"
                                    alt />
                                <p>Hotels</p>
                            </span>
                            <span class="prefer-list">
                                <img src="/static/images/images-new-theme/icons/airplane.svg" style="width:22px;height:15px;margin:0px 12px"
                                    alt />
                                <p>Airlines</p>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col-lg-6 customer-leads">
                    <div class="col-lg-8 col-md-8 customer-graph">
                        <fullscreen ref="Custom" @change="Change" style="background-color:#fff">
                            <div class="customer-ls ml-3 mt-2">
                                <button type="button"
                                    style="float:right;position:relative;left:12px;bottom:5px;outline:none;"
                                    @click="toggles">
                                    <img src="/static/images/exapand.svg" alt />
                                </button>
                                <span id="custom-text">Customer Filter</span>
                                <!-- <span class="dropdown customdrop" style="padding:10px">
                           <span class="btn btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="border:1px solid #d7dae2;color:#4d4f5c !important;border-radius:5px;font-size:8px">
                             All</span>
                          <span class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <a class="dropdown-item" href="#">A</a>
                            <a class="dropdown-item" href="#">b</a>
                            <a class="dropdown-item" href="#">c</a>
                          </span>
                </span>-->
                                <span></span>
                                <!-- <img src="/static/images/expand.png" style="width:20px;hieght:20px;float:right"> -->
                            </div>
                            <img src="/static/images/dashboard_graph_3.png" alt
                                style="width:100%;height:245px;margin-left:13px" />
                            <!-- <div id="chartdiv" style="position:relative;"></div> -->
                        </fullscreen>
                    </div>
                    <div class="col-lg-4 col-md-4 custom-sales">
                        <span class="custom-sales-text">Sales</span>
                        <span class="custom-sales-fore">
                            <img src="/static/images/SalesFor.svg" alt />
                            <h4>-</h4>
                            <h5>Forecast</h5>
                        </span>
                        <div class="salesAmt">
                            <span class="d-flex justify-content-between">
                                <span id="amtSale">
                                    <h4>-</h4>
                                    <h6>Closed</h6>
                                </span>
                                <span>
                                    <img src="/static/images/CloseAmt.svg" alt style="margin-top:12px" />
                                </span>
                            </span>
                            <hr style="margin:5px 0px;background-color:#fff" />
                            <span class="d-flex justify-content-between">
                                <span id="amtSale">
                                    <h4>-</h4>
                                    <h6>Open</h6>
                                </span>
                                <span>
                                    <img src="/static/images/OpenAmt.svg" alt style="margin-top:12px" />
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 custom-shedule" style="margin-left:-15px">
                    <div class="row">
                        <div class="col-lg-8 col-md-8 customlist">
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <div class="custom-list-details">
                                        <p id="custom-text">Scheduled Calls</p>
                                        <span class="d-flex justify-content-between mt-5">
                                            <img src="/static/images/Shedule.svg" alt />
                                            <span class="d-flex justify-content-between mt-1">
                                                <h4 id="custom-number">-</h4>
                                                <p id="custom-text-review">Calls</p>
                                            </span>
                                        </span>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 pl-0">
                                    <div class="custom-list-details">
                                        <p id="custom-text">Help Desk</p>
                                        <span class="d-flex justify-content-between mt-5">
                                            <span>
                                                <img src="/static/images/Recthelpdesk.svg" alt />
                                                <img src="/static/images/HDesk.svg" alt
                                                    style="position:relative;right:34px" />
                                            </span>
                                            <span class="d-flex justify-content-between mt-1">
                                                <h4 id="custom-number">-</h4>
                                                <p id="custom-text-review">Tickets</p>
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <fullscreen ref="fullscreen" @change="fullscreenChange"
                                style="background-color:#fff; border-radius:12px;">
                                <div class="barGraph"
                                    style="background-color:#fff;margin-top:10px;border-radius:4px;padding-left:13px;padding-right:13px;padding-bottom:4px">
                                    <button type="button" @click="toggle1"
                                        style="float:right;position:relative;left:12px;top: 1px;outline:none;">
                                        <img src="/static/images/exapand.svg" alt />
                                    </button>
                                    <p style="padding-top:6px">Calls vs Leads</p>
                                    <img src="/static/images/dashboard_graph_1.svg" alt
                                        style="width:100%;height:145px" />
                                    <!-- <div id="bargraph" style="position:relative;"></div> -->
                                </div>
                            </fullscreen>
                        </div>
                        <div class="col-lg-4 col-md-4 customer-leads-item px-0" style="padding-right:0px!important;">
                            <div class="customer-graphs">
                                <p>Leads</p>
                                <span>
                                    <img src="/static/images/Leads.svg" alt />
                                </span>
                                <h4 class="mt-4">-</h4>
                            </div>
                            <div class="customer-graphs mt-2">
                                <p>Deals</p>
                                <img src="/static/images/Deals1.svg" alt />
                                <img src="/static/images/Deals2.svg" alt style="position:relative;bottom:30px" />
                                <h4>13,425</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div class="d-flex mt-2 tableCloud">
                    <div class="col-lg-8 col-md-8 mb-3 table-responsive"
                        style="background-color:#fff;border-radius:4px">
                        <button type="button" style="float:right;position:relative;left:10px;top:5px;outline:none;"
                            @click="toggleTable">
                            <img src="/static/images/exapand.svg" alt />
                        </button>
                        <fullscreen ref="TableBudget" @change="TableChange" style="background-color:#fff;">
                            <table class="table table-budget" style="cursor: default">
                                <thead class="table-budgetHead">
                                    <tr style="border-bottom:2px solid whitesmoke">
                                        <th>Media</th>
                                        <th>Campaign Name</th>
                                        <th>Owner</th>
                                        <th>Product Name</th>
                                        <th>Start Date</th>
                                        <th>End Date</th>
                                        <th>Budget</th>
                                        <th>Spend</th>
                                        <th>Revenues</th>
                                    </tr>
                                </thead>
                                <tbody class="budgetData">
                                    <tr class="tbodydata" style="margin:0px 10px;padding:20px 20px">
                                        <td style="padding: 8px 12px !important;">
                                            <img src="/static/images/facebook1.svg" alt
                                                style="width:20px;height:20px" />
                                        </td>
                                        <td style="padding: 8px 12px !important;">Reynolds - Marks</td>
                                        <td style="padding: 8px 12px !important;">Karelle</td>
                                        <td style="padding: 8px 12px !important;">Bikes</td>
                                        <td style="padding: 8px 12px !important;">03 / 14 / 2020</td>
                                        <td style="padding: 8px 12px !important;">04 / 10 /2020</td>
                                        <td style="padding: 8px 12px !important;">$ 10,000</td>
                                        <td style="padding: 8px 12px !important;">$ 8,000</td>
                                        <td style="padding: 8px 12px !important;">$ 12,000</td>
                                    </tr>
                                    <tr class="tbodydata" style="margin:0px 10px">
                                        <td style="padding: 8px 12px !important;">
                                            <img src="/static/images/twit.svg" alt style="width:20px;height:20px" />
                                        </td>
                                        <td style="padding: 8px 12px !important;">Corwin Inc</td>
                                        <td style="padding: 8px 12px !important;">Concepcion</td>
                                        <td style="padding: 8px 12px !important;">Cars</td>
                                        <td style="padding: 8px 12px !important;">03 / 14 / 2020</td>
                                        <td style="padding: 8px 12px !important;">04 / 10 /2020</td>
                                        <td style="padding: 8px 12px !important;">$ 10,000</td>
                                        <td style="padding: 8px 12px !important;">$ 8,000</td>
                                        <td style="padding: 8px 12px !important;">$ 12,000</td>
                                    </tr>
                                    <tr class="tbodydata" style="margin:0px 10px">
                                        <td style="padding: 8px 12px !important;">
                                            <img src="/static/images/insta.svg" alt style="width:20px;height:20px" />
                                        </td>
                                        <td style="padding: 8px 12px !important;">Upton, Crist</td>
                                        <td style="padding: 8px 12px !important;">Maria</td>
                                        <td style="padding: 8px 12px !important;">Chips</td>
                                        <td style="padding: 8px 12px !important;">03 / 14 / 2020</td>
                                        <td style="padding: 8px 12px !important;">04 / 10 /2020</td>
                                        <td style="padding: 8px 12px !important;">$ 10,000</td>
                                        <td style="padding: 8px 12px !important;">$ 8,000</td>
                                        <td style="padding: 8px 12px !important;">$ 12,000</td>
                                    </tr>

                                    <tr class="tbodydata" style="margin:0px 10px">
                                        <td style="padding: 8px 12px !important;">
                                            <img src="/static/images/googles.svg" alt style="width:20px;height:20px" />
                                        </td>
                                        <td style="padding: 8px 12px !important;">Ledner, Berge</td>
                                        <td style="padding: 8px 12px !important;">Maida</td>
                                        <td style="padding: 8px 12px !important;">Mobile</td>
                                        <td style="padding: 8px 12px !important;">03 / 14 / 2020</td>
                                        <td style="padding: 8px 12px !important;">04 / 10 /2020</td>
                                        <td style="padding: 8px 12px !important;">$ 10,000</td>
                                        <td style="padding: 8px 12px !important;">$ 8,000</td>
                                        <td style="padding: 8px 12px !important;">$ 12,000</td>
                                    </tr>
                                    <tr class="tbodydata" style="margin:0px 10px">
                                        <td style="padding: 8px 12px !important;">
                                            <img src="/static/images/facebook1.svg" alt
                                                style="width:20px;height:20px" />
                                        </td>
                                        <td style="padding: 8px 12px !important;">Kilback - Price</td>
                                        <td style="padding: 8px 12px !important;">Katlynn</td>
                                        <td style="padding: 8px 12px !important;">Table</td>
                                        <td style="padding: 8px 12px !important;">03 / 14 / 2020</td>
                                        <td style="padding: 8px 12px !important;">04 / 10 /2020</td>
                                        <td style="padding: 8px 12px !important;">$ 10,000</td>
                                        <td style="padding: 8px 12px !important;">$ 8,000</td>
                                        <td style="padding: 8px 12px !important;">$ 12,000</td>
                                    </tr>
                                    <tr class="tbodydata" style="margin:0px 10px">
                                        <td style="padding: 8px 12px !important;">
                                            <img src="/static/images/googles.svg" alt style="width:20px;height:20px" />
                                        </td>
                                        <td style="padding: 8px 12px !important;">Jacobson</td>
                                        <td style="padding: 8px 12px !important;">Elmore</td>
                                        <td style="padding: 8px 12px !important;">Cotton Towels</td>
                                        <td style="padding: 8px 12px !important;">03 / 14 / 2020</td>
                                        <td style="padding: 8px 12px !important;">04 / 10 /2020</td>
                                        <td style="padding: 8px 12px !important;">$ 10,000</td>
                                        <td style="padding: 8px 12px !important;">$ 8,000</td>
                                        <td style="padding: 8px 12px !important;">$ 12,000</td>
                                    </tr>
                                    <tr class="tbodydata" style="margin:0px 10px">
                                        <td style="padding: 8px 12px !important;">
                                            <img src="/static/images/twit.svg" alt style="width:20px;height:20px" />
                                        </td>
                                        <td style="padding: 8px 12px !important;">McKenzie</td>
                                        <td style="padding: 8px 12px !important;">Elmore</td>
                                        <td style="padding: 8px 12px !important;">Computer</td>
                                        <td style="padding: 8px 12px !important;">03 / 14 / 2020</td>
                                        <td style="padding: 8px 12px !important;">04 / 10 /2020</td>
                                        <td style="padding: 8px 12px !important;">$ 10,000</td>
                                        <td style="padding: 8px 12px !important;">$ 8,000</td>
                                        <td style="padding: 8px 12px !important;">$ 12,000</td>
                                    </tr>
                                    <tr class="tbodydata" style="margin:0px 10px">
                                        <td style="padding: 8px 12px !important;">
                                            <img src="/static/images/insta.svg" alt style="width:20px;height:20px" />
                                        </td>
                                        <td style="padding: 8px 12px !important;">Marks and Gibson</td>
                                        <td style="padding: 8px 12px !important;">Angelita</td>
                                        <td style="padding: 8px 12px !important;">Cloths</td>
                                        <td style="padding: 8px 12px !important;">03 / 14 / 2020</td>
                                        <td style="padding: 8px 12px !important;">04 / 10 /2020</td>
                                        <td style="padding: 8px 12px !important;">$ 10,000</td>
                                        <td style="padding: 8px 12px !important;">$ 8,000</td>
                                        <td style="padding: 8px 12px !important;">$ 12,000</td>
                                    </tr>
                                </tbody>
                                <tfoot style="border-top:2px solid whitesmoke">
                                    <tr class="tfootData">
                                        <td colspan="5" style="padding: 8px 12px !important;"></td>
                                        <td class style="font-size:12px">Total</td>
                                        <td style="padding: 8px 12px !important;">$ 1,00,000</td>
                                        <td style="padding: 8px 12px !important;">$ 80,000</td>
                                        <td style="padding: 8px 12px !important;">$ 12,000</td>
                                    </tr>
                                </tfoot>
                            </table>
                        </fullscreen>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4 cloud-responsive pr-0">
                        <fullscreen ref="Cloud" @change="CloudChange"
                            style="background-color:#fff;border-radius:12px!important;">
                            <div class="cloudUsage mb-3"
                                style="background-color:#fff;border-radius:4px;padding-right:22px;padding-bottom:20px">
                                <button type="button" @click="toggleCloud"
                                    style="float:right;position:relative;left:20px;top:2px;overflow: hidden;outline:none;">
                                    <img src="/static/images/exapand.svg" alt />
                                </button>
                                <!-- <p class="ml-2 pt-2">Cloud Usage</p> -->
                                <!-- <span style="background-image: linear-gradient(181deg, #6db6f8 255%, rgba(109, 182, 248, 0.05) 4%);"></span> -->
                                <!-- <img src="/static/images/Cloud2.svg" alt="" style="margin-left:10px"> -->
                                <img src="/static/images/dashboard_chart_2.svg" alt id="cloudimge"
                                    style="height:127px;width:100%;margin-left:12px;margin-bottom:15px" />
                                <!-- <div id="chartCloud" style="position:relative;"></div> -->
                            </div>
                        </fullscreen>
                        <div class="cloud-expense mt-1"
                            style="background-color:#fff;border-radius:4px;padding-bottom:15px;cursor:default">
                            <div class="d-flex justify-content-between" style="padding-top:10px;margin-top:15px">
                                <span class="mt-2 ml-2">
                                    <p id="expense">Expenses</p>
                                </span>
                                <span class="d-flex mt-2 mr-4">
                                    <p class="expense-total mr-4">Total</p>
                                    <p class="expense-amt" style="font-size:16px">$ 120,000</p>
                                </span>
                            </div>
                            <div class="table-responsive">
                                <table class="table">
                                    <tbody>
                                        <tr class="tbodydata">
                                            <td style="padding: 8px 12px !important;">Travel</td>
                                            <td style="padding: 8px 12px !important;">Airport</td>
                                            <td style="padding: 8px 12px !important;">12 Sep 2019</td>
                                            <td style="color:#00448b">$ 60,000</td>
                                        </tr>
                                        <tr class="tbodydata">
                                            <td style="padding: 8px 12px !important;">Travel</td>
                                            <td style="padding: 8px 12px !important;">Airport</td>
                                            <td style="padding: 8px 12px !important;">12 Sep 2019</td>
                                            <td style="color:#00448b">$ 60,000</td>
                                        </tr>
                                        <tr class="tbodydata">
                                            <td style="padding: 8px 12px !important;">Travel</td>
                                            <td style="padding: 8px 12px !important;">Airport</td>
                                            <td style="padding: 8px 12px !important;">12 Sep 2019</td>
                                            <td style="color:#00448b">$ 60,000</td>
                                        </tr>
                                        <tr class="tbodydata">
                                            <td style="padding: 8px 12px !important;">Travel</td>
                                            <td style="padding: 8px 12px !important;">Airport</td>
                                            <td style="padding: 8px 12px !important;">12 Sep 2019</td>
                                            <td style="color:#00448b">$ 60,000</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="appblock"> -->
                <!-- <div class="products-content">
                        <div class="product-list">
                            <router-link :to="'/userprofile/' + this.loggedInUser._id" class="admin-card u-p-medium u-text-center u-mb-medium">
                                <div class="product-block">
                                    <div class="icon-block">
                                        <i class="crmnew-user"></i>
                                    </div>
                                </div>
                                <h4 class="u-h6 u-text-bold u-mb-small adminblockname">
                                    Profile
                                </h4>
                                <p class="u-app-desc">Profile Information</p>
                            </router-link>
                        </div>
                        <div class="product-list">
                            <router-link to="/managecompany" class="admin-card u-p-medium u-text-center u-mb-medium">
                                <div class="product-block">
                                    <div class="icon-block">
                                        <img class="u-mb-small-img i-company img-responsive" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/company.svg" alt="Company Profile icon">
                                        <img class="u-mb-small-img i-company i-company-hover img-responsive" src="/static/images/company-white.svg" alt="Company Profile icon">
                                    </div>
                                </div>
                                <h4 class="u-h6 u-text-bold u-mb-small adminblockname">
                                    Companies
                                </h4>
                                <p class="u-app-desc">Company Information</p>
                            </router-link>
                        </div>
                        <div class="product-list">
                            <router-link to="/callreport" class="admin-card u-p-medium u-text-center u-mb-medium">
                                <div class="product-block">
                                    <div class="icon-block">
                                        <i class="crmnew-callreport"></i>
                                    </div>
                                </div>
                                <h4 class="u-h6 u-text-bold u-mb-small adminblockname">
                                    Call Report
                                </h4>
                                <p class="u-app-desc">Record Meetings</p>
                            </router-link>
        </div>-->
                <!-- <div class="product-list">
                            <router-link to="/externaluser" class="admin-card u-p-medium u-text-center u-mb-medium">
                                <div class="product-block">
                                    <div class="icon-block">
                                        <img class="u-mb-small-img i-external img-responsive" src="/static/images/external-users.svg" alt="Company Profile icon">
                                        <img class="u-mb-small-img i-external-hover img-responsive" src="/static/images/external-users-white.svg" alt="Company Profile icon">
                                    </div>
                                </div>
                                <h4 class="u-h6 u-text-bold u-mb-small adminblockname">
                                    External Users
                                </h4>
                                <p class="u-app-desc">Manage External Users</p>
                            </router-link>
                        </div>
                        <div class="product-list">
                            <router-link to="/externalcompanies" class="admin-card u-p-medium u-text-center u-mb-medium">
                                <div class="product-block">
                                    <div class="icon-block">
                                        <img class="u-mb-small-img i-external img-responsive" src="/static/images/external-company.svg" alt="Company Profile icon">
                                        <img class="u-mb-small-img i-external-hover img-responsive" src="/static/images/external-company-white.svg" alt="Company Profile icon">
                                    </div>
                                </div>
                                <h4 class="u-h6 u-text-bold u-mb-small adminblockname">
                                    External Company
                                </h4>
                                <p class="u-app-desc">Manage External Companies</p>
                            </router-link>
        </div>-->
                <!-- </div>
                </div>
                <div class="appblock">
        <h3 class="purchased-products">Purchased Products</h3>-->
                <!-- <div class="products-content" v-match-heights="{ el: ['.c-card', '.productname'],disabled: [767, [920, 1200]]}">
                        <div class="product-list" v-for="product in products" v-bind:key="product.uid" v-if="activeProducts.indexOf(product.uid)>-1">
                            <a target="_blank" v-bind:href="product.url" class="c-card u-p-medium u-text-center u-mb-medium">
                                <div class="product-block">
                                    <div class="icon-block">
                                        <i class="logoicon" :class="product.icon"></i>
                                    </div>
                                </div>
                                <h4 class="u-h6 u-text-bold u-mb-small productname">
                                    {{ product.name }}
                                </h4>
                                <p class="u-app-desc">{{ product.description }}</p>
                            </a>
                        </div>
        </div>-->
                <!-- </div> -->
            </div>
        </div>
        <accept-two-step-verification v-if="accept_two_step_verification"
            @hideTwoStepVerification="hideTwoStepVerification" modal_name="two-step-verification">
        </accept-two-step-verification>
    </div>
</template>
<script>
    import {
        EventBus
    } from "./eventBus/nav-bar-event.js";
    import auth from './mixins/auth.js';
    const AcceptTwoStepVerification = () => import("./AcceptTwoStepVerification");

    export default {
        mixins: [auth],
        data() {
            return {
                //   products: [],
                //   activeProducts: [],
                //   order: true
                fullscreen: false,
                Custom: false,
                TableBudget: false,
                Cloud: false,
                accept_two_step_verification: false
            };
        },
        components: {
            AcceptTwoStepVerification
        },
        mounted() {
            // EventBus.$emit("detailsLoad", false);
            // EventBus.$emit("companiesLoad", false);
            this.customerFilter();
            this.callsDells();
            this.customCloud();
            if (this.loggedInUser.first_login === true) {
                this.checkTwoFactorVerification();
            }
        },
        methods: {
            async checkTwoFactorVerification() {
                try {
                    let params = {
                        login_id: this.loggedInUser.login_id
                    }
                    let response = await this.checkLogin(params);
                    if (response.status_id == 1 && response.is_two_step_verification == false) {
                        this.accept_two_step_verification = true;
                        setTimeout(() => {
                            this.$modal.show("two-step-verification");
                        }, 500);
                    }
                } catch (err) {
                    // console.log(err);
                }
            },
            hideTwoStepVerification() {
                this.accept_two_step_verification = false;
            },
            toggle1() {
                this.$refs["fullscreen"].toggle();
            },
            fullscreenChange(fullscreen) {
                this.fullscreen = fullscreen;
            },
            toggles() {
                this.$refs["Custom"].toggle();
            },
            Change(Custom) {
                this.Custom = Custom;
            },
            toggleTable() {
                this.$refs["TableBudget"].toggle();
            },
            TableChange(TableBudget) {
                this.TableBudget = TableBudget;
            },

            toggleCloud() {
                this.$refs["Cloud"].toggle();
            },
            CloudChange(Cloud) {
                this.Cloud = Cloud;
            },

            customerFilter() {
                am4core.ready(function () {
                    // Themes begin
                    am4core.useTheme(am4themes_animated);
                    // Themes end

                    // Create chart instance
                    var chart = am4core.create("chartdiv", am4charts.XYChart);

                    // Add data
                    chart.data = [{
                            date: new Date(2019, 0),
                            value1: 10000
                        },
                        {
                            date: new Date(2019, 1),
                            value1: 20000
                        },
                        {
                            date: new Date(2019, 2),
                            value1: 30000
                        },
                        {
                            date: new Date(2019, 3),
                            value1: 40000
                        },
                        {
                            date: new Date(2019, 4),
                            value1: 50000
                        },
                        {
                            date: new Date(2019, 5),
                            value1: 60000
                        },
                        {
                            date: new Date(2019, 6),
                            value1: 70000
                        },
                    ];

                    // Create axes
                    var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
                    dateAxis.renderer.minGridDistance = 10;

                    var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

                    // Create series
                    var series = chart.series.push(new am4charts.LineSeries());
                    series.dataFields.valueY = "value1";
                    series.dataFields.dateX = "date";
                    series.strokeWidth = 2;
                    series.fillOpacity = 0.2;

                    // Scrollbars
                    // chart.scrollbarX = new am4core.Scrollbar();
                    // chart.scrollbarY = new am4core.Scrollbar();
                });
            },
            callsDells() {
                am4core.ready(function () {
                    // Themes begin
                    am4core.useTheme(am4themes_animated);
                    // Themes end

                    // Create chart instance
                    var chart = am4core.create("bargraph", am4charts.XYChart);

                    // Add data
                    chart.data = [{
                            year: 2005,
                            income: 23.5,
                            expenses: 18.1,
                        },
                        {
                            year: 2006,
                            income: 26.2,
                            expenses: 22.8,
                        },
                        {
                            year: 2007,
                            income: 30.1,
                            expenses: 23.9,
                        },
                        {
                            year: 2008,
                            income: 29.5,
                            expenses: 25.1,
                        },
                        {
                            year: 2009,
                            income: 24.6,
                            expenses: 25,
                        },
                    ];

                    // Create axes
                    var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
                    categoryAxis.dataFields.category = "year";
                    categoryAxis.numberFormatter.numberFormat = "#";
                    categoryAxis.renderer.inversed = true;
                    categoryAxis.renderer.grid.template.location = 0;
                    categoryAxis.renderer.cellStartLocation = 0.1;
                    categoryAxis.renderer.cellEndLocation = 0.9;

                    var valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
                    valueAxis.renderer.opposite = true;

                    // Create series
                    function createSeries(field, name) {
                        var series = chart.series.push(new am4charts.ColumnSeries());
                        series.dataFields.valueX = field;
                        series.dataFields.categoryY = "year";
                        series.name = name;
                        series.columns.template.tooltipText = "{name}: [bold]{valueX}[/]";
                        series.columns.template.height = am4core.percent(100);
                        series.sequencedInterpolation = true;

                        var valueLabel = series.bullets.push(new am4charts.LabelBullet());
                        valueLabel.label.text = "{valueX}";
                        valueLabel.label.horizontalCenter = "left";
                        valueLabel.label.dx = 10;
                        valueLabel.label.hideOversized = false;
                        valueLabel.label.truncate = false;

                        var categoryLabel = series.bullets.push(new am4charts.LabelBullet());
                        categoryLabel.label.text = "{name}";
                        categoryLabel.label.horizontalCenter = "right";
                        categoryLabel.label.dx = -10;
                        categoryLabel.label.fill = am4core.color("#fff");
                        categoryLabel.label.hideOversized = false;
                        categoryLabel.label.truncate = false;
                    }

                    createSeries("income", "Income");
                    createSeries("expenses", "Expenses");
                });
            },
            customCloud() {
                am4core.ready(function () {
                    // Themes begin
                    am4core.useTheme(am4themes_animated);
                    // Themes end

                    // Create chart instance
                    var chart = am4core.create("chartCloud", am4charts.XYChart);

                    // Add data
                    chart.data = [{
                            date: new Date(2019, 0),
                            value1: 10
                        },
                        {
                            date: new Date(2019, 1),
                            value1: 20
                        },
                        {
                            date: new Date(2019, 2),
                            value1: 30
                        },
                        {
                            date: new Date(2019, 3),
                            value1: 10
                        },
                        {
                            date: new Date(2019, 4),
                            value1: 50
                        },
                        {
                            date: new Date(2019, 5),
                            value1: 60
                        },
                        {
                            date: new Date(2019, 6),
                            value1: 70
                        },
                    ];

                    // Create axes
                    var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
                    dateAxis.renderer.minGridDistance = 10;

                    var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

                    // Create series
                    var series = chart.series.push(new am4charts.LineSeries());
                    series.dataFields.valueY = "value1";
                    series.dataFields.dateX = "date";
                    series.strokeWidth = 2;
                    series.fillOpacity = 0.2;
                });
            },
            // getProductsSorted: function() {
            //   var sorted = [];
            //   if (this.order) {
            //     for (var key in this.products) {
            //       sorted[sorted.length] = this.products[key];
            //     }
            //     return sorted.sort(function(a, b) {
            //       if (a.name < b.name) return -1;
            //       if (a.name > b.name) return 1;
            //       return 0;
            //     });
            //   } else {
            //     for (var key in this.products) {
            //       sorted[sorted.length] = this.products[key];
            //     }
            //     return sorted.sort(function(a, b) {
            //       if (a.name > b.name) return -1;
            //       if (a.name < b.name) return 1;
            //       return 0;
            //     });
            //   }
            // },
            // getProducts() {
            //   var vueThis = this;
            //   var _params = JSON.stringify({});
            //   this.$https
            //     .post("/get_products", JSON.stringify({}))
            //     .then(function(response) {
            //       console.log("-------getProducts: ", response);
            //       console.log(this, vueThis, "::::::::::::::");
            //       vueThis.products = response.data.products;
            //       vueThis.products = vueThis.getProductsSorted();
            //       vueThis.activeProducts = response.data.activeProducts;
            //       console.log(
            //         "_______________________((((((((())))))))_________________________"
            //       );
            //       console.log(vueThis.activeProducts);
            //       console.log(vueThis.products);
            //     })
            //     .catch(function(error) {
            //       console.log("error in getProducts", error);
            //     });
            // }
        },

        created() {
            // this.getProducts();
        },

        computed: {
            loggedInUser() {
                return this.$store.getters.loggedInUser;
            },
            account() {
                return this.$store.getters.account;
            },
        },
    };
</script>
<style scoped>
    .headerblock {
        margin-top: 5px;
    }

    .section-bg-image {
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;
        overflow: hidden;
    }

    .container.content-app,
    .section-empty>.content-app,
    .section-bg-image>.content-app,
    .section-bg-video>.content-app,
    .section-bg-animation>.content-app,
    .section-slider>.content-app,
    .section-two-blocks .content-app {
        padding-top: 60px;
        padding-bottom: 60px;
    }

    @media (min-width: 993px) {

        .container.content-app,
        .section-empty>.content-app,
        .section-bg-image>.content-app,
        .section-bg-video>.content-app,
        .section-bg-animation>.content-app,
        .section-slider>.content-app,
        .section-two-blocks .content-app {
            padding-top: 80px;
            padding-bottom: 80px;
        }

        [class*="boxed"].col-md-8:not(.no-margins) {
            width: calc(66.66666667% - 80px);
        }

        [class*="boxed"].col-md-12:not(.no-margins) {
            width: calc(100% - 30px);
        }

        [class*="col-md-"].boxed,
        [class*="col-md-"].boxed-inverse {
            margin: 0 40px;
        }

        .base-box.boxed,
        .base-box.boxed-inverse,
        .boxed-inverse,
        [class*="col-md-"].boxed,
        [class*="col-md-"].boxed-inverse,
        .grid-box>.grid-item.boxed-inverse,
        .row.vertical-row>div.boxed-inverse,
        .row.vertical-row>div.boxed {
            padding: 50px;
            border-radius: 6px;
        }

        .max-250 {
            max-width: 250px;
        }
    }

    [class*="section-"]>div>.row:last-child>div>*:last-child,
    [class*="section-"]>div>*:last-child,
    [class*="section-"]>*:last-child {
        margin-bottom: 0;
    }

    [class*="section-"]>div>.row:first-child>div>*:first-child,
    [class*="section-"]>div>*:first-child,
    [class*="section-"]>*:first-child {
        margin-top: 0;
    }

    div.content-app {
        padding-left: 15px;
        padding-right: 15px;
    }

    .base-box.boxed,
    .base-box.boxed-inverse,
    .boxed-inverse,
    [class*="col-md-"].boxed,
    [class*="col-md-"].boxed-inverse,
    .grid-box>.grid-item.boxed-inverse,
    .row.vertical-row>div.boxed-inverse,
    .row.vertical-row>div.boxed {
        border-style: none !important;
    }

    .shadow-1,
    .adv-img-down-text.shadow-1 .img-box,
    .two-blocks-container.shadow-1>.row,
    .section-bg-color .advs-box.boxed-inverse,
    .section-bg-color .adv-img.boxed-inverse {
        box-shadow: 0 2px 15px rgba(0, 0, 0, 0.13) !important;
    }

    .black {
        color: #303031 !important;
    }

    .col-center {
        float: none !important;
        margin-left: auto !important;
        margin-right: auto !important;
        clear: both;
        padding-top: 20px;
    }

    .section-bg-image .advs-box.boxed-inverse,
    .black .flex-control-paging li a:hover,
    .adv-img-down-text.boxed-inverse:hover,
    .advs-box-multiple div.circle,
    .list-blog input,
    .list-blog select,
    .section-bg-image [class*="col-md-"].boxed-inverse,
    [class*="shadow-"].boxed-inverse,
    .sidebar-nav ul ul,
    .base-box.boxed,
    .base-box.boxed-inverse,
    .advs-box.boxed-inverse,
    .section-bg-color .form-box .form-control,
    .boxed-inverse:not(.shadow-1) .form-box,
    .boxed-inverse:not(.shadow-1) .form-box .form-control,
    .section-two-blocks .form-box .form-control,
    .section-bg-color .advs-box.boxed-inverse {
        background-color: #fff;
    }

    hr.space {
        border: none !important;
        clear: both;
        height: 70px;
        margin: 0;
        -webkit-box-sizing: content-box;
        -moz-box-sizing: content-box;
        box-sizing: content-box;
    }

    .text-l {
        line-height: 38px;
    }

    .text-l {
        font-size: 27px !important;
        line-height: 31px;
    }

    .grid-list {
        position: relative;
    }

    .grid-box.row {
        margin: -20px;
        width: calc(100% + 40px);
    }

    .grid-box>.grid-item {
        padding: 20px;
    }

    .app-box.app-box-top-bottom {
        display: block;
    }

    .grid-item>div {
        padding-left: 0;
        padding-right: 0;
    }

    .app-box-top-bottom .app-box-cell {
        display: block;
        text-align: center;
    }

    .app-box-cell {
        vertical-align: middle;
    }

    .app-box.app-box-top-bottom .app-box-cell>img {
        margin: 0px 0 15px 0;
    }

    .app-box.app-box-top-bottom .app-box-cell>img {
        float: none;
        margin: 7px 0 7px 0;
        display: inline-block;
    }

    .app-box-cell img.text-xl {
        width: 55px;
    }

    .app-box.app-box-top-bottom .app-box-cell>i {
        float: none;
        margin: 7px 0 7px 0;
        display: inline-block;
    }

    .app-box.app-box-top-bottom .app-box-cell>i {
        margin: 0px 0 15px 0;
        color: #5584ff;
    }

    .app-box-cell i.text-xl {
        width: 55px;
        font-size: 55px;
        height: 55px;
        line-height: 55px;
    }

    .app-box-top-bottom .app-box-cell label {
        margin-bottom: 10px;
    }

    .app-box-top-bottom .app-box-cell label {
        padding: 0;
    }

    .app-box label {
        font-weight: 600;
    }

    .app-box-top-bottom .app-box-cell p {
        padding: 0;
        margin-bottom: 0;
        margin: 0;
    }

    .grid-item p {
        height: auto;
    }

    .text-s {
        line-height: 20px;
        font-size: 13px !important;
    }

    body.fuse-aside-folded:not(.fuse-aside-expanded) #aside .aside-content-wrapper,
    body.fuse-aside-folded:not(.fuse-aside-expanded) #aside .aside-content-wrapper>.aside-content {
        width: 0rem !important;
        min-width: 0rem !important;
    }

    body.fuse-aside-folded:not(.fuse-aside-expanded) #aside {
        width: 0rem;
    }

    .layout.layout-vertical.fuse-aside-folded.layout-left-navigation .wrapper {
        padding-left: 0rem;
    }

    h3.purchased-products {
        font-size: 16px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1px;
        text-align: left;
        color: #00448b;
        text-transform: uppercase;
        padding-bottom: 10px;
        padding-left: 32px;
    }

    .nav-link {
        text-decoration: none;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        height: 48px;
        padding: 0 24px;
        position: relative;
        overflow: hidden;
        cursor: pointer;
        font-size: 14px;
    }

    .layout .wrapper>.aside>.aside-content-wrapper>.aside-content>#sidenav .nav-link {
        color: #303031;
    }

    .nav-link i,
    .nav-link [class^="icon-"],
    .nav-link [class*=" icon-"] {
        font-size: 24px !important;
        margin-right: 1.9rem;
    }

    .dropdown-toggle.dropdownhideafter::after {
        content: none !important;
    }

    .dropdown-toggle.text-white::after {
        color: #fff !important;
    }

    .dropdown-apps {
        left: -120px;
        width: 320px;
        min-height: 100px;
        max-height: 400px;
        overflow-y: auto;
    }

    .uk-margin-bottom {
        margin-bottom: 16px !important;
    }

    .uk-grid:after,
    .uk-grid:before {
        content: "";
        display: block;
        overflow: hidden;
    }

    [class*="uk-grid-width"]>* {
        box-sizing: border-box;
        width: 100%;
    }

    .uk-grid-width-medium-1-3>* {
        width: 33.333%;
    }

    .uk-margin-top {
        margin-top: 15px !important;
    }

    @media (min-width: 1220px) {
        .uk-grid>* {
            padding-left: 0px;
        }
    }

    .uk-grid>* {
        -ms-flex: none;
        -webkit-flex: none;
        flex: none;
        margin: 0;
        float: left;
        text-align: center;
        text-decoration: none;
    }

    i.material-icons.md-36 {
        font-size: 36px !important;
        vertical-align: -36px;
        line-height: 36px;
        height: 36px;
        width: 36px;
        padding-bottom: 15px;
        color: rgb(86, 130, 251);
    }

    .uk-grid>*> :last-child {
        margin-bottom: 0;
    }

    .uk-text-muted {
        color: #303031 !important;
    }

    .uk-display-block {
        display: block !important;
    }

    #todo .search-bar {
        height: 5.6rem;
        background: #fafafa;
        -webkit-box-shadow: none;
        box-shadow: none;
    }

    .page-layout.carded.left-sidebar .page-content-wrapper,
    .page-layout.carded.right-sidebar .page-content-wrapper {
        padding: 0rem;
    }

    .g-color-gray-dark-v6 {
        color: #53585e !important;
    }

    .g-bg-gray-light-v8 {
        background-color: #eee !important;
        font-weight: 500;
    }

    .g-font-size-default {
        font-size: 1.4rem !important;
    }

    .g-rounded-50 {
        border-radius: 50px !important;
    }

    .g-brd-around {
        border: solid 1px transparent !important;
    }

    .u-tags-v1 {
        display: inline-block;
        text-decoration: none;
        transition: all 0.3s ease;
    }

    @media (min-width: 0) {
        .g-py-4 {
            padding-top: 0.28571rem !important;
            padding-bottom: 0.28571rem !important;
        }

        .g-px-15 {
            padding-left: 1.07143rem !important;
            padding-right: 1.07143rem !important;
        }

        .g-mr-8 {
            margin-right: 0.57143rem !important;
        }
    }

    [class*="u-badge-v2"] {
        border-radius: 50%;
        display: inline-block;
        text-align: center;
        font-size: 0.92857rem;
        color: #333;
        z-index: 3;
        font-weight: 300;
    }

    .u-badge-v2--md {
        width: 14px;
        height: 14px;
    }

    .g-pos-stc {
        position: static !important;
    }

    .g-transform-origin--top-left {
        -webkit-transform-origin: top left;
        -ms-transform-origin: top left;
        transform-origin: top left;
    }

    .g-bg-lightblue-v3 {
        background-color: #1cc9e4 !important;
    }

    .g-bg-primary {
        background-color: #e62154 !important;
    }

    .u-p-medium {
        padding: 1.175rem 0rem !important;
    }

    .u-mb-medium {
        margin-bottom: 1rem !important;
    }

    .u-text-center {
        text-align: center !important;
    }

    .c-card {
        position: relative;
        display: block;
        text-decoration: none;
        cursor: pointer;
        outline: 0;
    }

    .admin-card {
        position: relative;
        display: block;
        text-decoration: none;
        cursor: pointer;
        outline: 0;
    }

    .product-block {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .icon-block {
        width: 120px;
        height: 90px;
        border-radius: 15px;
        color: #00448b;
        border: solid 1px #4b9be6;
        padding: 0;
        margin: 0;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 15px;
    }

    .icon-block:hover {
        background-color: #00448b;
    }

    .icon-block:hover i {
        color: #fff;
    }

    .icon-block.icon-block-active {
        border-radius: 15px;
        background-color: #00448b;
    }

    .icon-block i {
        color: #00448b;
    }

    .icon-block i.icons-users {
        width: 65px;
        height: 35px;
        line-height: 35px;
        font-size: 30px;
    }

    .icon-block i.icons-company-profile {
        width: 43px;
        height: 42px;
        line-height: 42px;
        font-size: 30px;
    }

    .icon-block i.icons-products {
        width: 31px;
        height: 55px;
        line-height: 55px;
        font-size: 30px;
    }

    .icon-block span.icons-chat .path1 {
        width: 42px;
        height: 42px;
        line-height: 42px;
        font-size: 42px;
        margin-right: -10px;
    }

    .icon-block span.icons-chat .path2 {
        width: 16.8px;
        height: 18.5px;
        line-height: 18.5px;
        font-size: 42px;
        background-color: #ffffff;
    }

    .icon-block i.logoicon {
        width: 43px;
        height: 42px;
        line-height: 42px;
        font-size: 42px;
    }

    .icon-block i.logoicon.logo-cloud,
    .icon-block i.logoicon.logo-crm {
        width: 54px;
    }

    .icon-block i.logoicon.logo-pos,
    .icon-block i.logoicon.logo-pay,
    .icon-block i.logoicon.logo-play {
        width: 60px;
    }

    .icon-block span.icons-chat .path2:before {
        color: #ffffff;
    }

    .icon-block:hover span.icons-chat .path1 {
        color: #ffffff;
    }

    .icon-block:hover span.icons-chat .path2:before {
        color: #00448b;
    }

    .icon-block.icon-block-active i {
        color: #fff;
    }

    .c-card:hover {
        text-decoration: none;
    }

    .admin-card:hover {
        text-decoration: none;
    }

    .u-mb-small-img.i-company {
        width: 43px;
        height: 42px;
    }

    .icon-block:hover .u-mb-small-img.i-company {
        display: none;
    }

    .icon-block .u-mb-small-img.i-company-hover {
        display: none;
    }

    .icon-block:hover .u-mb-small-img.i-company-hover {
        display: block;
    }

    .u-mb-small-img.i-external {
        width: 43px;
        height: 42px;
    }

    .icon-block:hover .u-mb-small-img.i-external {
        display: none;
    }

    .icon-block .u-mb-small-img.i-external-hover {
        display: none;
    }

    .icon-block:hover .u-mb-small-img.i-external-hover {
        display: block;
        width: 43px;
        height: 42px;
    }

    .u-mb-small {
        margin-bottom: 1.375rem !important;
    }

    .u-text-bold {
        font-weight: 600 !important;
    }

    .u-h6 {
        font-size: 15px;
        margin: 0 0 0.5rem;
        padding-bottom: 7px;
        color: #303031;
        padding: 0;
    }

    .u-app-desc {
        padding-bottom: 15px;
        color: #4e5764 !important;
        font-size: 13px;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        margin-bottom: 0.5rem;
    }

    .appblock {
        padding: 0px 15px 0px 15px;
    }

    .form-group input[type="text"].form-control::-webkit-input-placeholder,
    .form-group>.input-group input[type="text"].form-control::-webkit-input-placeholder,
    .form-group>.input-group>.form-control::-webkit-input-placeholder,
    .form-group input[type="email"].form-control::-webkit-input-placeholder,
    .form-group input[type="password"].form-control::-webkit-input-placeholder,
    textarea.form-control::-webkit-input-placeholder {
        /* Chrome */
        color: rgba(0, 0, 0, 0.3) !important;
        opacity: 1;
        font-size: 14px;
    }

    .form-group input[type="text"].form-control:-ms-input-placeholder,
    .form-group>.input-group input[type="text"].form-control:-ms-input-placeholder,
    .form-group input[type="email"].form-control:-ms-input-placeholder,
    .form-group input[type="password"].form-control:-ms-input-placeholder,
    textarea.form-control:-ms-input-placeholder {
        /* IE 10+ */
        color: rgba(0, 0, 0, 0.3) !important;
        opacity: 1;
        font-size: 14px;
    }

    .form-group input[type="text"].form-control::-moz-placeholder,
    .form-group>.input-group input[type="text"].form-control::-moz-placeholder,
    .form-group input[type="email"].form-control::-moz-placeholder,
    .form-group input[type="password"].form-control::-moz-placeholder,
    textarea.form-control::-moz-placeholder {
        /* Firefox 19+ */
        color: rgba(0, 0, 0, 0.3) !important;
        opacity: 1 !important;
        font-size: 14px;
    }

    .form-group input[type="text"].form-control:-moz-placeholder,
    .form-group>.input-group input[type="text"].form-control:-moz-placeholder,
    .form-group input[type="email"].form-control:-moz-placeholder,
    .form-group input[type="password"].form-control:-moz-placeholder,
    textarea.form-control:-moz-placeholder {
        /* Firefox 4 - 18 */
        color: rgba(0, 0, 0, 0.3) !important;
        opacity: 1 !important;
        font-size: 14px;
    }

    .form-group textarea.form-control:hover,
    .form-check textarea.form-control:hover {
        -webkit-box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.87);
        box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.87);
    }

    .form-group textarea.form-control,
    .form-check textarea.form-control {
        -webkit-box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.42);
        box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.42);
    }

    .form-group textarea.form-control:focus,
    .form-check textarea.form-control:focus:hover {
        -webkit-box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.42);
        box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.42);
    }

    .form-group textarea.form-control:focus,
    .form-group textarea.form-control:focus:hover {
        -webkit-box-shadow: 0 2px 0 0 #3c4252 !important;
        box-shadow: 0 2px 0 0 #3c4252 !important;
    }

    .products-content {
        display: flex;
        flex-wrap: wrap;
    }

    .product-list {
        list-style: none;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-flex-flow: row wrap;
        justify-content: space-around;
        padding: 0px 25px;
        margin: 10px 0px;
        width: 205px;
    }

    /* upadte */
    .prodItem {
        background-color: #fff;
        border-radius: 4px;
        padding: 15px;
    }

    .prod-content {
        display: flex;
        flex-flow: wrap;
    }

    .prod-text {
        font-family: Poppins;
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 0.75;
        letter-spacing: normal;
        text-align: left;
        color: #4d4f5c;
        margin: 10px 5px;
        cursor: default;
    }

    .prod-list-item {
        display: flex;
        justify-content: space-between;
        margin: 20px 5px;
    }

    .prod-list-con {
        display: flex;
        justify-content: space-between;
        margin: 20px 5px 0px 5px;
    }

    .prod-list #prod-number {
        font-family: Poppins;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        color: #4d4f5c;
        margin: 10px 5px;
    }

    .prod-list-item #prod-number {
        cursor: default;
    }

    .prod-list-con p,
    h4 {
        cursor: default;
    }

    .prefer-list p {
        cursor: default;
    }

    #GrpPeople {
        width: 25px;
        height: 30px;
        position: relative !important;
        left: 45px;
    }

    .preference-item {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
    }

    .prefer-list {
        display: flex;
        flex-direction: row;
        margin-top: 7px;
    }

    .prefer-list p {
        font-family: Poppins;
        font-size: 11px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.4;
        letter-spacing: normal;
        text-align: left;
        color: #4d4f5c;
        margin-left: 30px;
    }

    .prod-list-item span {
        font-family: Poppins;
        font-size: 10px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 0.5;
        letter-spacing: normal;
        text-align: left;
        color: #4d4f5c;
    }

    .customer-leads {
        display: flex;
        flex-direction: row;
        gap: 15px;
        margin-right: 15px;
    }

    .customer-graph {
        background-color: #fff;
        border-radius: 4px !important;
        display: flex;
        flex-direction: column;
        /* margin: 0px 10px 0px 0px; */
    }

    .customer-graphs {
        background-color: #fff;
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        align-items: center;
        /* width: 203px; */
        height: 143px;
    }

    .customer-graphs p {
        font-family: Poppins;
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        color: #4d4f5c;
        margin-top: 10px;
        cursor: default;
    }

    .customer-graphs h4 {
        font-family: Poppins;
        font-size: 18px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        color: #4d4f5c;
        cursor: default;
    }

    .customer-leads-item {
        display: flex;
        flex-direction: column;
    }

    .custom-list {
        margin: 0px;
        display: flex;
        flex-flow: wrap;
        justify-content: space-between;
    }

    .custom-list-details {
        background-color: #fff;
        border-radius: 4px;
        padding: 10px;
        /* width: 190px; */
    }

    #custom-text {
        font-family: Poppins;
        font-size: 10px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: left;
        color: #4d4f5c;
        cursor: default;
    }

    #custom-number {
        font-family: Poppins;
        font-size: 22px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: center;
        color: #4d4f5c;
    }

    #custom-text-review {
        font-family: Poppins;
        font-size: 8px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: right;
        color: #4d4f5c;
        margin-right: 30px;
        margin-top: 11px;
        margin-left: 15px;
        cursor: default;
    }

    .custom-sales {
        border-radius: 4px;
        background-color: #005dae;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }

    .custom-sales-text {
        font-family: Poppins;
        font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        color: #fff;
        margin: 10px 0px;
        cursor: default;
    }

    .custom-sales-fore {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .custom-sales-fore h4 {
        font-family: Poppins;
        font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        color: #fff;
        cursor: default;
    }

    .custom-sales-fore h5 {
        font-family: Poppins;
        font-size: 10px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        color: #fff;
        cursor: default;
    }

    .salesAmt {
        border-radius: 8px !important;
        background-color: #6db6f8;
        padding: 10px;
        width: 100%;
        border-radius: 2px;
    }

    #amtSale h4 {
        font-family: Poppins;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        color: #fff;
        cursor: default;
    }

    #amtSale h6 {
        font-family: Poppins;
        font-size: 10px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        color: #fff;
        cursor: default;
    }

    #chartdiv {
        width: 100%;
        height: 230px;
    }

    #bargraph {
        width: 100%;
        height: 100%;
    }

    .table .table-budgetHead th {
        font-family: Poppins;
        font-size: 10px !important;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: left;
        color: #4d4f5c;
    }

    .budgetData {
        font-family: Poppins;
        font-size: 10px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        color: #4d4f5c;
    }

    .tbodydata td {
        font-family: Poppins;
        font-size: 10px;
        font-weight: normal !important;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        color: #4d4f5c;
        padding: 8px 12px !important;
    }

    .tfootData td {
        font-family: Poppins;
        font-size: 10px;
        font-weight: bold !important;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        color: #4d4f5c;
        padding: 8px 12px !important;
    }

    #expense {}

    .expense-total {
        font-family: Poppins;
        font-size: 10px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: left;
        color: #4e4e4e;
        padding-top: 5px;
    }

    .expense-amt {
        font-family: Poppins;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: left;
        color: #4e4e4e;
    }

    .barGraph p {
        cursor: default;
    }

    @media screen and (min-width: 300px) {
        .barGraph {
            padding-left: 30px !important;
        }
    }

    @media screen and (min-width: 300px) and (max-width: 762px) {
        .custom-sales {
            margin-top: 10px;
            padding-left: 30px;
        }

        .salesAmt {
            padding-left: 10px;
            margin-left: 15px;
            margin-bottom: 10px;
        }

        .custom-list-details {
            padding: 10px !important;
        }

        .customer-graph {
            margin-bottom: 10px;
        }

        .customer-ls {
            margin-right: 10px;
            cursor: default;
        }

        .customlist {
            padding-right: 0px !important;
        }
    }

    @media screen and (min-width: 352px) and (max-width: 768px) {
        .custom-list-details {
            padding: 30px !important;
            margin-bottom: 10px;
            /* margin-left: 15px; */
        }

        .prodItem {
            margin-bottom: 10px;
            padding-left: 20px;
        }

        .barGraph {
            padding-left: 30px !important;
        }
    }

    @media screen and (min-width: 768px) and (max-width: 1024px) {
        .prodItem {
            margin-bottom: 10px;
        }

        #cloudimge {
            height: 180px !important;
        }

        .custom-list-details {
            margin-left: 15px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard.vue